import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Card, CardBody, CardHeader, CircularProgress } from "@nextui-org/react";
import { useTranslation } from "react-i18next";
import { BsDatabaseFill } from "react-icons/bs";

import Table from "../../../components/Table";
import { financial_insights_table_columns } from "../../../constants/tableHeaders";
import ACircleUserDisplay from "../../../components/Kit/ACircleUserDisplay";

import { getTopFlopSales } from "../../../utils/financialInsightsUtils";
import GenericTable from "../../../components/Kit/GenericTable";
import { capitalizeFirstLetter } from "../../../utils/stringUtils";

const TopFlopTable = () => {
  const { t } = useTranslation();
  const { sales, loading_sales } = useSelector(
    (state) => state.financial_insights.financial_insights
  );

  const [topFlopCalls, setTopFlopCalls] = useState([]);

  useEffect(() => {
    if (sales && sales?.length >= 0) {
      const filtered_sales = getTopFlopSales(sales);
      setTopFlopCalls(filtered_sales);
    }
  }, [sales]);

  const renderCardHeader = () => {
    return (
      <div className="w-full flex items-center justify-between gap-x-4">
        <h6 className="text-[24px] font-semibold text-primary">{t("Top/Flop")}</h6>
      </div>
    );
  };

  const onOperatorClick = (item) => () => {};

  const tableEmptyContent = () => {
    return (
      <div className="w-full h-full flex-1 flex flex-col items-center justify-center">
        <BsDatabaseFill className="text-gray-300 w-12 h-12" />
        <h3 className="text-sm text-gray-400 mt-3">{t("No records to display")}</h3>
      </div>
    );
  };

  const renderCell = (item, columnKey) => {
    const cellValue = item[columnKey];
    switch (columnKey) {
      case "name":
        return (
          <ACircleUserDisplay
            firstname={capitalizeFirstLetter(item.first_name)}
            lastname={capitalizeFirstLetter(item.last_name)}
            email={item.email}
          />
        );
      case "team":
        return <div className="font-normal text-sm text-[#404040]/[0.6]">{item.team}</div>;
      case "outgoing_calls_count":
        return (
          <div className="font-normal text-sm text-[#404040]/[0.6]">
            {item?.outgoing_calls_count || 0}
          </div>
        );
      case "revenue":
        return (
          <div className="font-normal text-sm text-[#404040]/[0.6]">
            {item?.revenue === 0
              ? item?.revenue
              : (item?.revenue || 0).toLocaleString("fr-FR", { maximumFractionDigits: 0 })}
            €
          </div>
        );
      default:
        return <span className="text-sm text-[#404040]/[0.6]">{cellValue}</span>;
    }
  };

  if (loading_sales) {
    // TODO: render loading
    // return <Loader />;
  }

  return (
    <Card
      className="w-full h-full rounded-md shadow-custom-light px-[12px] py-[20px]"
      shadow="none"
    >
      <CardHeader className="py-0 px-[20px]">{renderCardHeader()}</CardHeader>
      <CardBody className="w-full h-full min-h-[300px] p-0 pb-3 box-border">
        {loading_sales ? (
          <div className="flex flex-col justify-center items-center w-auto h-96 m-auto text-sm">
            <CircularProgress
              aria-label="Loading..."
              color="primary"
              label="Loading..."
            />
          </div>
        ) : topFlopCalls?.length > 0 ? (
          <GenericTable
            items={topFlopCalls}
            titles={financial_insights_table_columns}
            getItemContent={renderCell}
            onRowClick={onOperatorClick}
            isClickable={false}
          />
        ) : (
          tableEmptyContent()
        )}
      </CardBody>
    </Card>
  );
};

export default TopFlopTable;
